import { themeColors } from '@/config/theme-colors'

const light = themeColors.light
const dark = themeColors.dark

export default {
  presets: {
    light: {
      backgroundPrimary: light.backgroundPrimary,
      backgroundSecondary: light.backgroundSecondary,
      backgroundTertiary: light.backgroundTertiary,
      backgroundElement: light.backgroundElement,
      backgroundBorder: light.backgroundBorder,
      textPrimary: light.textPrimary,
      textSecondary: light.textSecondary,
      textTertiary: light.textTertiary,
      textInverted: light.textInverted,
      backgroundCardPrimary: light.backgroundCardPrimary,
      backgroundCardSecondary: light.backgroundCardSecondary,
      primary: light.primary,
      primaryDark: light.primaryDark,
      secondary: light.secondary,
      accent: light.accent,
      success: light.successColor,
      info: light.info,
      danger: light.dangerColor,
      warning: light.warningColor,
    },
    dark: {
      backgroundPrimary: dark.backgroundPrimary,
      backgroundSecondary: dark.backgroundSecondary,
      backgroundTertiary: dark.backgroundTertiary,
      backgroundElement: dark.backgroundElement,
      backgroundBorder: dark.backgroundBorder,
      textPrimary: dark.textPrimary,
      textSecondary: dark.textSecondary,
      textTertiary: dark.textTertiary,
      textInverted: dark.textInverted,
      backgroundCardPrimary: dark.backgroundCardPrimary,
      backgroundCardSecondary: dark.backgroundCardSecondary,
      primary: dark.primary,
      primaryDark: dark.primaryDark,
      secondary: dark.secondary,
      accent: dark.accent,
      success: dark.successColor,
      info: dark.info,
      danger: dark.dangerColor,
      warning: dark.warningColor,
    },
  },
}
